import { Button, Container, Text, Box } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';
import { logout } from '../../../store/auth/actions';
import { PageHeader } from 'shared-components';
import { titleAppend } from '../../../utilities/head';
import { useDispatch } from 'react-redux';
import { useSession } from 'shared-components/authentication';

const NoActiveIntake = () => {
  const pageTitle = 'You have no active intakes';

  const session = useSession();
  const dispatch = useDispatch();

  const onLogout = async () => {
    await session.onLogout();
    dispatch(logout());
  };

  return (
    <>
      <Helmet>
        <title>
          {pageTitle} {titleAppend}
        </title>
      </Helmet>

      <Container as="main" my={{ base: 8, md: 16 }}>
        <PageHeader>{pageTitle}</PageHeader>

        <Text fontSize="lg">
          If you feel you have outstanding CAS, visa or arrival tasks, please contact the university so they can review
          and update your student record.
        </Text>

        <Box textAlign="center">
          <Button onClick={onLogout} size="lg" variant="solid">
            Log out
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default NoActiveIntake;
